// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const RunFileOut = zod.object({
  "content_type": zod.string(),
  "filename": zod.string(),
  "id": zod.uuid(),
  "size_bytes": zod.int(),
  "text_chars": zod.union([zod.int(),zod.null()]),
  "text_status": zod.string(),
  "text_truncated": zod.boolean()
});

export type RunFileOut = zod.input<typeof RunFileOut>;
export type RunFileOutOutput = zod.output<typeof RunFileOut>;
